

import React, { memo, useState } from 'react';
import { Link } from '../../../../ui-kit';

import EditReply from '../../components/CommentPopover/components/EditCommentPopover/components/EditReply';
import CommentBody from '../../components/Comment/components/CommentBody';
import CommentFooter from '../../components/Comment/components/CommentFooter';
import { getUser } from '../../../../common/utils';
import './_replies.scss';

const INITIAL_REPLIES_COUNT = 2;

















function Replies({
  replies,
  updateEditorState,
  resourceId,
  onUpdateContent,
  parentComment,
  handleEdit,
  handleDelete,
  commentIdToEdit,
  editReply,
  deleteReply,
  isResourceOwner,
  clearInput,
  onInputFocus
}) {
  const [allRepliesVisible, toggleRepliesVisibility] = useState(false);

  if (!replies.length) {return null;}

  const visibleReplies = allRepliesVisible ?
  replies :
  replies.slice(replies.length - INITIAL_REPLIES_COUNT, replies.length);
  const additionalRepliesCount = replies.length - INITIAL_REPLIES_COUNT;

  return (
    <div className="comment-replies">
      {
      replies.length > 2 ?

      <Link
        button
        onClick={() => toggleRepliesVisibility(!allRepliesVisible)}
        className="comment-replies__toggle-more-replies">

              {
        allRepliesVisible ?
        'Hide older replies' :
        `Show ${additionalRepliesCount} more ${additionalRepliesCount === 1 ? 'reply' : 'replies'}`}

            </Link> :

      null}

      {visibleReplies.map((reply) =>
      <div className="comment-replies__reply" key={reply.commentId}>
          {
        commentIdToEdit !== reply.commentId ?

        <>
                  <CommentBody small content={reply.content} />
                  <CommentFooter
            isResourceOwner={isResourceOwner}
            user={getUser(reply.createdByUser)}
            handleDelete={
            handleDelete &&
            handleDelete({ deleteReply, commentId: reply.commentId, parentComment })}

            handleEdit={handleEdit && handleEdit({ replyComment: reply })}
            updatedAt={reply.updatedAt} />

                </> :

        <EditReply
          commentId={reply.commentId}
          editReply={editReply}
          comment={parentComment || reply}
          createdByUser={reply.createdByUser}
          onUpdateContent={onUpdateContent}
          editorState={updateEditorState}
          clearInput={clearInput}
          visible
          resourceOrganisationId={resourceId || ''}
          onInputFocus={onInputFocus} />}





        </div>
      )}
    </div>);

}

export default memo(Replies);